<i18n src="./resources/locales.json" > </i18n>

<template>
  <v-card id="loading-wrapper" tile class="surface darken-1" :style="CSS_VARS">
    <div id="loading-text">{{ $t('loadingText') }}</div>
    <div id="loading-content" />
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {

  name: 'SmsLoadingSpinner',

  computed: {
    ...mapGetters('themes', ['selectedThemeName', 'getThemeByName']),
    CSS_VARS() {
      return {
        '--outer-color': this.theme.primary,
        '--inner-color': this.theme.secondary,
        '--bg-color': this.theme.surface,
        '--info-color': this.theme.info,
        '--success-color': this.theme.success,
        '--error-color': this.theme.error
      };
    },
    theme() {
      return this.getThemeByName(this.selectedThemeName);
    }
  }
};
</script>

<style scoped>
#loading-wrapper {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: #222;
}

#loading-text {
  display: block;
  position: absolute;
  top: calc(50% - 35px);
  left: calc(50% - 50px);
  color: inherit;
  width: 100px;
  text-align: center;
  font-family: 'Avenir Book', sans-serif;
  font-size: 20px;
}

#long-load-time-message {
  display: block;
  position: absolute;
  top: calc(50% + 120px);
  left: calc(50% - 225px);
  color: inherit;
  width: 450px;
  text-align: center;
  font-family: 'Avenir Book', sans-serif;
  font-size: 16px;
}

#loading-content {
  display: block;
  position: relative;
  top: calc(50% - 100px);
  left: calc(50% - 100px);
  width: 200px;
  height: 200px;
  border: 3px solid var(--error-color, #f00);
}

#loading-content:after {
  content: '';
  position: absolute;
  border: 3px solid var(--success-color, #0f0);
  left: 15px;
  right: 15px;
  top: 15px;
  bottom: 15px;
}

#loading-content:before {
  content: '';
  position: absolute;
  border: 3px solid var(--info-color, #00f);
  left: 5px;
  right: 5px;
  top: 5px;
  bottom: 5px;
}

#loading-content {
  border: 3px solid transparent;
  border-top-color: var(--outer-color, #f47920);
  border-bottom-color: var(--outer-color, #f47920);
  border-radius: 50%;
  -webkit-animation: loader 2s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
  animation: loader 2s linear infinite;
}

#loading-content:before {
  border: 3px solid transparent;
  border-top-color: white;
  border-bottom-color: white;
  border-radius: 50%;
  -webkit-animation: loader 3s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
  animation: loader 3s linear infinite;
}

#loading-content:after {
  border: 3px solid transparent;
  border-top-color: var(--inner-color, #1F7DB8);
  border-bottom-color: var(--inner-color, #1F7DB8);
  border-radius: 50%;
  -webkit-animation: loader 1.5s linear infinite;
  animation: loader 1.5s linear infinite;
  -moz-animation: loader 2s linear infinite;
  -o-animation: loader 2s linear infinite;
}

@-webkit-keyframes loaders {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loader {
  0% {
    -webkit-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
